import { faCheck, faCheckCircle, faCheckDouble, faCheckSquare, faMinus, faTimes, faTimesCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function QuestionsArr({qustionsArr, setUserSelectedQuestion, expired}) {
    const selectQuestionClicked = (question)=>{
        if(question.userAnswered && question.success ===-1 && !expired){
            setUserSelectedQuestion(question._id)
        }
    }
    if(!qustionsArr || !qustionsArr.length) return <></>
  return (
    <div className={`question-arr`}>
        {qustionsArr.map((question,inx)=>{
           return(  <div key={question._id} onClick={()=>selectQuestionClicked(question)} className={`question-item ${question.userAnswered?'answered' :'not-answered'} ${(question.userAnswered  && question.success===-1)?' clickable':''} ${(question.curr)?' curr':''}` }>
              <span className="num">{inx+1}</span>  
{(question.userAnswered && question.success===1 ) && <FontAwesomeIcon color="green"  icon={faCheckCircle} /> }
{(question.userAnswered  && question.success===0) && <FontAwesomeIcon color="red"  icon={faTimesCircle} /> }
{(question.userAnswered  && question.success===-1) && <FontAwesomeIcon  icon={faCheck} /> }
{(!question.userAnswered  )  && <FontAwesomeIcon  icon={faMinus} /> }
            </div>)
        })}
    </div>
  )
}

export default QuestionsArr